import { defineAsyncComponent } from "vue";
export default [
  {
    name: "PersonalLessonAttemptCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "PersonalLessonAttemptEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "PersonalLessonAttemptSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "section/:sectionId",
    props: true,
  },
  {
    name: "PersonalLessonAttemptSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "section/:sectionId/end",
    props: true,
  },
  {
    name: "PersonalLessonAttemptActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    name: "PersonalLessonAttemptCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "PersonalLessonAttemptConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    name: "PersonalLessonAttemptPasscode",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonPasscode")),
    path: "passcode",
    props: true,
  },
  {
    path: "not-found",
    name: "PersonalLessonNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
